import { render } from "./HeroiconsSolidLightBulb.vue?vue&type=template&id=25bd834b"
const script = {}

import exportComponent from "D:\\Programs\\Projects\\www\\cae-new-web\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidLightBulb.vue"]])

export default __exports__